import React from "react";

interface GridSectionProps {
  children: React.ReactNode;
  dark?: boolean;
  className?: string;
  withDotMatrix?: boolean | "sm" | "lg" | "corner";
  withGridLines?: boolean | "cross";
  id?: string;
  "data-testid"?: string;
}

export function GridSection({
  children,
  dark = false,
  className,
  withDotMatrix,
  withGridLines,
  id,
  "data-testid": testId,
}: GridSectionProps) {
  const bgClass = dark ? "bg-charcoal" : "bg-cream";

  let dotMatrixClass = "";
  if (withDotMatrix === true) dotMatrixClass = dark ? "bg-dot-matrix-light" : "bg-dot-matrix";
  else if (withDotMatrix === "sm") dotMatrixClass = dark ? "bg-dot-matrix-sm-light" : "bg-dot-matrix-sm";
  else if (withDotMatrix === "lg") dotMatrixClass = dark ? "bg-dot-matrix-lg-light" : "bg-dot-matrix-lg";
  else if (withDotMatrix === "corner") dotMatrixClass = dark ? "" : "bg-dot-matrix-corner";

  let gridLinesClass = "";
  if (withGridLines === true) gridLinesClass = dark ? "bg-grid-lines-light" : "bg-grid-lines";
  else if (withGridLines === "cross") gridLinesClass = dark ? "bg-grid-lines-cross-light" : "bg-grid-lines-cross";

  return (
    <section
      className={`relative ${bgClass} ${className ?? ""}`}
      id={id}
      data-testid={testId}
    >
      {dotMatrixClass && (
        <div className={`absolute inset-0 ${dotMatrixClass} pointer-events-none`} aria-hidden="true" />
      )}
      {gridLinesClass && (
        <div className={`absolute inset-0 ${gridLinesClass} pointer-events-none`} aria-hidden="true" />
      )}
      <div className="relative z-10">
        {children}
      </div>
    </section>
  );
}
